module.exports = __webpack_public_path__ + "img/精准美肤--大图.a42c9e72.png";